import { render, staticRenderFns } from "./service-config-actions-bar.component.vue?vue&type=template&id=2aaff6f1&scoped=true"
import script from "./service-config-actions-bar.component.vue?vue&type=script&lang=ts"
export * from "./service-config-actions-bar.component.vue?vue&type=script&lang=ts"
import style0 from "./service-config-actions-bar.component.vue?vue&type=style&index=0&id=2aaff6f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaff6f1",
  null
  
)

export default component.exports